export default "__VITE_ASSET__9a446a2b__"